import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import hoverAnimations from "@insite/mobius/Button/hoverAnimations";
import ButtonPresentationPropsDefault from "@insite/mobius/Button/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { applyTypography } from "@nishtech/MobiusOverrides/utilities/getColor";
import { fancyboxStyles } from "@nishtech/Store/Nishtech/FancyboxStyles";
import { nishtechStyles } from "@nishtech/Store/Nishtech/NishtechStyles";
import Color from "color";
import { css } from "styled-components";

// For production, include a set of commonly used widgets in the main bundle
// the rest will be split into their own chunks
// Do not do this for the ./Overrides folder
const widgets = IS_PRODUCTION
    ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
    : require.context("./Widgets", true, /\.tsx$/);
// enable hot module reloading for widgets
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id.toString(), () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
// const pages = require.context("./Pages", true, /\.tsx$/);
// const onHotPageReplace = addPagesFromContext(pages);
// if (module.hot) {
//     module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
// }

// const store = require.context("./Store", true);
// store.keys().forEach(key => store(key));

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

// in production, the widget extensions are included in the chunks created for widgets
// if (!IS_PRODUCTION) {
//     // load all widget extensions. They could be loaded individually instead
//     const widgetExtensions = require.context("./WidgetExtensions", true);
//     widgetExtensions.keys().forEach(key => widgetExtensions(key));
// }

// load all widgets. Without this they won't be included in the bundle
// const widgets = IS_PRODUCTION
//     ? require.context("./Widgets", true, /(Header|Basic|Common|Footer|SignIn)\/.+?\.tsx$/)
//     : require.context("./Widgets", true, /\.tsx$/);
// const onHotWidgetReplace = addWidgetsFromContext(widgets);
// if (module.hot) {
//     module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
// }

setPreStyleGuideTheme({
    globalStyle: {
        css: css`
            /* Set the pre-style guide theme - only global styles*/
            
            html {
                -webkit-text-size-adjust: 100%;
                line-height: 1.15;
                width: 100%;
                height: 100%;
                margin: 0px;
                padding: 0px;
                overflow-x: hidden;
            }
            body {
                margin: 0;
            }
            @media (max-width: 540px) {
                main 
                {
                 max-width:90%!important;
                }
            }
            main:not([data-test-selector="homePage"]) {
                display: block;
                /*  max-width: 1310px !important;*/
            }
            h1 {
                font-size: 2em;
                margin: 0.67em 0;
            }
            hr {
                box-sizing: content-box;
                height: 0;
                overflow: visible;
            }
            pre {
                font-family: monospace, monospace;
                font-size: 1em;
            }
            a {
                background-color: transparent;
            }
            abbr[title] {
                border-bottom: none;
                text-decoration: underline;
                -webkit-text-decoration: underline dotted;
                text-decoration: underline dotted;
            }
            b,
            strong {
                font-weight: bolder;
            }
            code,
            kbd,
            samp {
                font-family: monospace, monospace;
                font-size: 1em;
            }
            small {
                font-size: 80%;
            }
            sub,
            sup {
                font-size: 75%;
                line-height: 0;
                position: relative;
                vertical-align: baseline;
            }
            sub {
                bottom: -0.25em;
            }
            sup {
                top: -0.5em;
            }
            img {
                border-style: none;
            }
            button,
            input,
            optgroup,
            select,
            textarea {
                font-family: inherit;
                font-size: 100%;
                line-height: 1.15;
                margin: 0;
            }
            button,
            input {
                overflow: visible;
            }
            button,
            select {
                text-transform: none;
            }
            [type="button"],
            [type="reset"],
            [type="submit"],
            button {
                -webkit-appearance: button;
            }
            button:focus {
                outline: none !important;
            }
            div:focus {
                outline: none !important;
            }
            span:focus {
                outline: none !important;
            }
            [type="button"]::-moz-focus-inner,
            [type="reset"]::-moz-focus-inner,
            [type="submit"]::-moz-focus-inner,
            button::-moz-focus-inner {
                border-style: none;
                padding: 0;
            }
            [type="button"]:-moz-focusring,
            [type="reset"]:-moz-focusring,
            [type="submit"]:-moz-focusring,
            button:-moz-focusring {
                outline: 1px dotted ButtonText;
            }
            fieldset {
                padding: 0.35em 0.75em 0.625em;
            }
            progress {
                vertical-align: baseline;
            }
            textarea {
                overflow: auto;
            }
            [type="checkbox"],
            [type="radio"] {
                box-sizing: border-box;
                padding: 0;
            }
            [type="number"]::-webkit-inner-spin-button,
            [type="number"]::-webkit-outer-spin-button {
                height: auto;
            }
            [type="search"] {
                -webkit-appearance: textfield;
                outline-offset: -2px;
            }
            [type="search"]::-webkit-search-decoration {
                -webkit-appearance: none;
            }
            ::-webkit-file-upload-button {
                -webkit-appearance: button;
                font: inherit;
            }
            details {
                display: block;
            }
            summary {
                display: list-item;
            }
            [hidden],
            template {
                display: none;
            }

            @font-face {
                font-display: block;
                font-family: icomoon;
                font-style: normal;
                font-weight: 400;
                src: url(/UserFiles/fonts/icomoon.woff?yuzzw2) format("woff");
            }
            [class*=" icon-"],
            [class^="icon-"] {
                speak: none;
                font-feature-settings: normal;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                font-family: icomoon !important;
                font-style: normal;
                font-variant: normal;
                font-weight: 400;
                line-height: 1;
                text-transform: none;
            }
            .icon-chevron-down:before {
                content: "\e908";
            }
            .icon-cross:before {
                content: "\e90d";
            }
            .icon-chevron-up:before {
                content: "\e911";
            }
            .icon-chevron-left:before {
                content: "\e912";
            }
            .icon-chevron-right:before {
                content: "\e913";
            }
            html {
                box-sizing: border-box;
            }
            *,
            :after,
            :before {
                box-sizing: inherit;
            }
            .visually-hidden {
                clip: rect(0, 0, 0, 0);
                border: 0;
                height: 1px;
                margin: -1px;
                overflow: hidden;
                padding: 0;
                position: absolute;
                white-space: nowrap;
                width: 1px;
            }
            .visually-hidden.focusable:active,
            .visually-hidden.focusable:focus {
                clip: auto;
                height: auto;
                margin: 0;
                overflow: visible;
                position: static;
                white-space: inherit;
                width: auto;
            }
            @font-face {
                font-display: swap;
                font-family: ITC Avant Garde Gothic;
                font-style: normal;
                font-weight: 500;
                src:
                    url(/UserFiles/fonts/ITCAvantGardeGothic-Medium.woff2) format("woff2"),
                    url(/UserFiles/fonts/ITCAvantGardeGothic-Medium.woff) format("woff");
            }
            @font-face {
                font-display: swap;
                font-family: ITC Avant Garde Gothic;
                font-style: normal;
                font-weight: 700;
                src:
                    url(/UserFiles/fonts/ITCAvantGardeGothic-Bold.woff2) format("woff2"),
                    url(/UserFiles/fonts/ITCAvantGardeGothic-Bold.woff) format("woff");
            }
            @font-face {
                font-display: swap;
                font-family: ITC Avant Garde Gothic CE;
                font-style: normal;
                font-weight: 400;
                src:
                    url(/UserFiles/fonts/ITCAvantGardeGothicCEBook-Regular.woff2) format("woff2"),
                    url(/UserFiles/fonts/ITCAvantGardeGothicCEBook-Regular.woff) format("woff");
            }
            body {
                margin: 0;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                background-color: #fff;

                ${applyTypography("body")}
            }
            a {
                color: ${getColor("primary.main")};
                transition: color 0.35s cubic-bezier(0.3, 0.86, 0.36, 0.95);
            }
            a,
            a:hover {
                -webkit-text-decoration: none;
                text-decoration: none;
            }
            a:focus {
                outline: none !important;
            }
            dl,
            ol,
            p,
            ul {
                margin: 0 0 22px;
            }

            input[type="email"],
            input[type="search"],
            input[type="tel"],
            input[type="text"],
            textarea {
                -webkit-appearance: none;
                background-color: transparent;
                border: 1px solid;
                border-radius: 0;
                min-width: 0;
                padding: 1.2rem 2.4rem;
                transition: border-color 0.35s cubic-bezier(0.3, 0.86, 0.36, 0.95);
                width: 100%;
            }
            input[type="email"]:focus,
            input[type="email"]:hover,
            input[type="search"]:focus,
            input[type="search"]:hover,
            input[type="tel"]:focus,
            input[type="tel"]:hover,
            input[type="text"]:focus,
            input[type="text"]:hover,
            textarea:focus,
            textarea:hover {
                box-shadow: none;
                outline: none;
            }
            input[type="search"]::-webkit-search-cancel-button,
            input[type="search"]::-webkit-search-decoration,
            input[type="search"]::-webkit-search-results-button,
            input[type="search"]::-webkit-search-results-decoration {
                display: none;
            }
            td span {
                font-size: inherit !important;
            }
            button[data-test-selector="productCompareRemoveProductButton"] span svg
            {
            color:${getColor("primary.main")};
            }
            @media (min-width: 991px){
            div[data-test-selector="productList_pagination"] .page-numbers.start svg
            ,div[data-test-selector="productList_pagination"] .page-numbers.prev svg
            ,div[data-test-selector="productList_pagination"] .page-numbers.next svg
            ,div[data-test-selector="productList_pagination"] .page-numbers.end svg
            {
                margin-top: 4px;
                margin-bottom: 2px !important;
            }
            }
            @media (min-width: 768px) and (max-width: 991px){
            div[data-test-selector="productList_pagination"] .page-numbers.start svg
            ,div[data-test-selector="productList_pagination"] .page-numbers.prev svg
            ,div[data-test-selector="productList_pagination"] .page-numbers.next svg
            ,div[data-test-selector="productList_pagination"] .page-numbers.end svg
            {
                margin-top: 4px !important;
            }
            }
            @media (max-width: 767px){
                div[data-test-selector="productList_pagination"] .page-numbers.start svg
                ,div[data-test-selector="productList_pagination"] .page-numbers.prev svg
                ,div[data-test-selector="productList_pagination"] .page-numbers.next svg
                ,div[data-test-selector="productList_pagination"] .page-numbers.end svg
                {
                    margin-top: 3px !important;
                }
            }
            .as-header-row.as-header-top
            {
                max-width:95%
            }
            @media (min-width: 992px) and (max-width: 1199px) {
                div[data-test-selector='page_OrderHistoryPage'] .pf-breadcrumbs-wrapper{
                max-width: 1000px;
                }
                div[data-test-selector='page_OrderHistoryPage'] main{
                        max-width: 1000px;
                        padding: 15px;
                    }
                div[data-test-selector="orderHistoryTags_FromDate"] > span:first-child
                {
                    margin-top: 8px;
                }
            }
            .wishlist-line-notes-grid-item p[data-test-selector="heading"]
            {
            color:#2A2B2A};
            font-size: 13px;
            }
           
            @media (min-width: 768px) and (max-width: 850px)
            {
                div[data-test-selector="scheduleReminderModal"] .react-datetime-picker
                {
                padding-right: 18px !important;
                }
            }
            @media (max-width: 767px) {
                .as-producs-list-section .as-col-filters .as-h2
                {
                    font-size: 26px;
                    font-weight: 600;
                    line-height: 24px;
                }
                div[data-test-selector="productList_pagination"] .as-pagination-holder .as-pagination h2
                {
                    font-size: 20px;
                    font-weight: 700;
                    line-height: 25px;
                }
            }

            main[data-test-selector="myAccount"] ul.navigation-list[data-test-selector="navigationList"] .navigation-list-item ul{
            margin-bottom:0px
            }
            ul.navigation-list[data-test-selector="navigationList"]
            {
                margin-top: 10px;
            }
            div[data-test-selector="page_MyAccountPage"] h2
                {
                font-size: 26px;
                font-weight: 650;
                line-height: 1.26;
                }
            @media (min-width: 992px) and (max-width: 1199px) {
                div[data-test-selector="page_MyAccountPage"] main[data-test-selector="myAccount"]
                {
                    max-width:98%
                }
            }
            @media (min-width: 768px) and (max-width: 991px) {
             div[data-test-selector="page_MyAccountPage"] main[data-test-selector="myAccount"]
                {
                    max-width:96%
                }
            }
            @media (min-width: 576px) and (max-width: 767px) {
                div[data-test-selector="page_MyAccountPage"] main[data-test-selector="myAccount"]
                {
                    max-width:96%
                }
            }
            @media (max-width: 575px) {
                div[data-test-selector="page_MyAccountPage"] main[data-test-selector="myAccount"]
                {
                    max-width:96%
                }
            }
            @media (max-width: 400px) {
                div[data-test-selector="page_MyAccountPage"] main[data-test-selector="myAccount"] div:has(>.view-all-link)
                    {
                        padding-left: 0px;
                    }
            }
            @media (max-width: 326px) {
                div[data-test-selector="page_MyAccountPage"] main[data-test-selector="myAccount"] div:has(>.view-all-link)
                    {
                        padding-right: 5px;
                    }
            }
            @media (min-width: 1024px){
            div[data-test-selector="productList_pagination"] .page-numbers.start svg
            ,div[data-test-selector="productList_pagination"] .page-numbers.prev svg
            ,div[data-test-selector="productList_pagination"] .page-numbers.next svg
            ,div[data-test-selector="productList_pagination"] .page-numbers.end svg
            {
                margin-top: 10px !important;
            }
            }
            @media (max-width: 767px) 
            {
              .cart-icon-wrapper
                {
                    top: 1px;
                    height: 25px;
                }
                .as-user-control > li.as-account-block > a 
                {
                    height: 24px;
                }
            }
            @media (min-width: 1024px) 
            {
                .as-user-control > li.as-account-block > a {
                    height: 24px;
                    width: 23px;
                }
                .cart-icon-wrapper
                {
                    top: 7px;
                }
            }
            @media (min-width: 768px) and (max-width: 1024px)
            {
                .as-user-control > li.as-account-block > a 
                {
                    height: 25px;
                }
                .cart-icon-wrapper
                {
                    top: 5px;
                    height: 26px;
                }
            }
           
            div[class*=ToastStyle] button[class*="ButtonWrapper"]
            {
                top: 3px;
                right: 3px;
                width: initial;
                height: initial;
            }
            #genericForm{
            width:90%;
            max-width:767px;
            margin: 0 auto;    
            }
            @media (min-width: 768px)
            {
                 #genericForm{max-width:900px;}
            }
            .custom-form-input-container
            {
                margin-bottom:10px;
            }
            @media (min-width: 1024px) and (max-width:1140px){
                .page-holder {
                    padding-top: 105px !important;                
                }
            }
            @media (max-width: 1024px){
                .as-navigation .as-nav-drop{
                    top: 105px;
                }

                ul.as-sort-list
                {
                    z-index: 99999 !important;
                }
                .as-header .as-user-control
                {
                top:80%;
                
                }
                .as-header .as-user-control .as-account-block
                {
                    margin-top: 5px;
                }
                .cart-icon-wrapper .cart-superscript{
                    top: 0px !important;
                }
            }
            @media (max-width: 767px) {
                .as-header .as-user-control .as-account-block {
                    margin-top: 2px;
                }
            }
            .user-admin-form-container
            {
                min-width: fit-content;
            }
            div[data-test-selector="page_OrderDetailsPage"] div[data-test-selector*="orderLineCard"] p[data-test-selector="heading"]
            {
            font-size:10px;
            }
            @media (max-width: 767px) {
            div[data-test-selector="page_OrderDetailsPage"] div[data-test-selector*="orderLineCard"] .order-product-info-qty {
                flex: 1 1 50%;
            }
            }
            .as-product-list.grid-view .as-product-item .as-qty-holder
            {
                position: relative;
            }
            .as-product-list.grid-view .as-product-item .as-qty-holder .as-link-holder
            {
                bottom: -30px;
            }
            @media (min-width: 1139px) {
            .as-product-list.grid-view .as-product-item .as-qty-holder .as-link-holder
            {
                bottom: -10px;
            }
            }
            @media (max-width: 400px) {
                .as-product-list.list-view .as-qty-holder .as-qty-item{
                    margin-bottom: 6px;
                }
            }
            @media (min-width: 1366px) {
                .as-product-list.grid-view .as-product-item .as-qty-holder .as-input-count {
                    margin-bottom: 12px;
                }
            }
            .as-product-item .as-qty-holder .as-qty-text
            {
                color :rgb(84, 88, 89)
            }

            @media (min-width: 1364px) {
                .as-product-list.grid-view .as-product-item .as-qty-holder .as-btn {
                    letter-spacing: 0.03em;
                    padding-bottom: 12px;
                    padding-top: 12px;
                    text-align: center;
                    width: 100%;
                    max-width:285px;
                }
            }
            .as-product-list .as-product-item button[data-test-selector="availabilityByWarehouseLink"]
            {
                padding-bottom:5px;
                padding-top:5px;
            }
            @media (max-width: 767px) {
                span[data-test-selector="checkout_estimatedDelivery"]
                {
                padding-right: 0px;
                }
            }
            main[data-test-selector="homePage"] {
                padding-top: 40px;
            }
            @supports not (-webkit-touch-callout: none) {
                .as-wrapper > *: first-child {
                    position: fixed; top: 0; left: 0; width: 100%; z-index: 1000;
                }
            }
            @supports (-webkit-touch-callout: none)
            {.page-holder {
                padding-top: 0px !important;
            }}
            .as-container .as-header-nav-wrap::before {
                right: calc(50% - 50vw)!important;
            }
            .custom-mobile-menu .as-dropdown
            {top:0px}
            .custom-mobile-menu .as-sub-dropdown
            {top:0px}
            .custom-mobile-menu {display: block;}
            .cascading-menu li[data-test-selector="menuItem"] span
            {
            font-size:12px!important;
            }
            .autocomplete-wrapper{
                // min-width: 450px;
                flex-direction: column-reverse;
            } 
            div[id*="headerSearch-"]{
                width: -webkit-fill-available;
                max-width: 450px;
                border-radius: 10px;
                top: 92px!important;
                }
            div[id*="headerSearch-"] > div:first-child {
            width: 100%;
            }
            .as-producs-list-section .as-product-list.list-view .as-product-desc .as-qty-text {
                margin-left: 270px;
            }
            @media (min-width: 1280px) {
                .as-producs-list-section .as-product-list.list-view .as-product-desc {
                    width: 100%!important;
                }
            }
            .as-producs-list-section .as-product-list.list-view .as-product-desc .as-um-text {
                margin-right: 60px;
            }
            .as-producs-list-section .as-box-filter
            {
                margin-bottom:0px;
            }
            label[data-test-selector="cartline_qty-label"]
            {
                color: rgb(223, 35, 35);
                line-height: 1.5;
                font-size: 15px;
                text-transform: uppercase;
                font-weight: 600;
                font-family: "Inter Tight", Arial, sans-serif;
                margin: 0px;
            }
            p[data-test-selector="text_Subtotal"]
            {
                margin-left:10px;
            }
            p[data-test-selector="text_QTY"]
            {
                margin-left:10px;
            }
            button[data-test-selector="applyPromotionCodeButton"]
            {
                margin-top: 33px;
            }
            div[data-test-selector="quoteDetail_cardLine_qty"] p[data-test-selector="text_QTY"]
            {
            margin-left:10px;
            }
            div[data-test-selector="quoteDetail_cardLine_qty"] p[data-test-selector="text_Subtotal"]
            {
            margin-left:10px;
            }
            @media (min-width: 576px) {
                .checkoutshipping-cancel-btn{margin-left: auto !important;}
                }
            .checkoutReviewAndSubmit_backButton_container{
                max-width: fit-content;
                margin-left: auto!important;
            }

            .checkout_estimatedDelivery_container{
                max-width: fit-content;
            }
            .checkout_estimatedDelivery_container span[data-test-selector="checkout_estimatedDelivery"]
            {     padding-right: 0px;}
            .SkipSignInForPriceMessage span[data-test-selector="productPrice_PricingMessage"]
            {
                display:none!important;
            }
            div[data-test-selector="page_ProductDetailsPage"] .qtyUomContainer input[data-test-selector="product_qtyOrdered"]
            {
                max-width: -webkit-fill-available;
            }
            .productPrice_extendedPrice_container{
            padding-left:5px!important;
            }
            @media (min-width: 767px) {
            .as-cart-popup .as-close
                {
                    top:40px!important;
                    background-color:#fff!important;
                }
            }
            @media (min-width: 1024px) 
            {
            div[data-test-selector="page_ProductDetailsPage"] .as-poduct-detail-slider .as-image {
                    height: 350px;
                    padding: 10px;
                    // border: solid #545859;
                    // border-width: 1.5px 0;
                }
            .as-poduct-detail-slider .as-image img
            {
                max-height:330px
            }
            .as-poduct-detail-slider .zoom-icon
            {
                right: 0px;
                top: 0px;
            }
            }
            
            .singleUnitOfMeasure
            {
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
            }
            .infoInnerContainer .bodyRowItem {
                height: auto;
                min-height: fit-content;
            }
            .imageColItem
            {
                align-items: end;
            }

            @media (min-width: 768px) and (max-width: 991px) {
            .bodyRowContainer>:first-child {
            display: flex;
            flex-wrap: wrap;
            }

            .bodyRowContainer .attributesItem {
            flex: 0 0 50%;
            max-width: 50%;
            }

            .bodyRowContainer .availabilityItem {
            flex: 0 0 100%;   /* forces new row */
            order:3;
            }

            .bodyRowContainer .actionsItem {
            flex: 0 0 50%;
            max-width: 50%;
            order:2;
            }
            }
            div[data-test-selector*="productCarousel_"] .as-history-carousel
            {
                visibility:hidden;
            }
            .as-history-carousel.slick-initialized.slick-slider
            {
                visibility:visible;
            }
            // .as-history-carousel-wrap .spinner_carousel
            // {
            //     display:inline-block;
            //     margin-left:50%;
            // }
            .as-history-carousel-wrap .spinner_carousel {
                display: none!important;
            }
            @media (max-width: 1023px) {
                .as-sub-sub-nav-item.as-selected > .as-sub-sub-dropdown {
                    transform: none;
                    top: 0;
                }
            }
            /* adding nishtech styles below to override any of the common stylings */
            ${nishtechStyles.cssOverride.css}
            ${fancyboxStyles.cssOverride.css}
        `,
    },
    colors: {
        primary: {
            main: "#042359",
            contrast: "#FFFFFF",
        },
        secondary: {
            main: "#55A9CB",
            contrast: "#FFFFFF",
        },
        text: {
            main: "#042359",
            disabled: "#ffffff",
            accent: "#ffffff",
            link: "#042359",
        },
        common: {
            background: "#FFFFFF",
            backgroundContrast: "#2A2B2A",
            accent: "#FFFFFF",
            accentContrast: "#FFFFFF",
            border: "#CCCCCC",
            disabled: "#CCCCCC",
        },
    },
    typography: {
        body: {
            size: "16px",
            weight: 400,
            lineHeight: "1.5",
            color: "text.main",
            fontFamily: "Roboto Condensed, sans-serif",
            css: css`
                backgroundcolor: #fff;
                margin: 0;
                overflow-x: hidden;
                text-rendering: optimizeLegibility;
            `,
        },
        p: {
            size: "16px",
            weight: 400,
            lineHeight: 1.5,
            css: css`
                margin-bottom: 1em;
                display: block;
            `,
        },
        h1: {
            fontFamily: "Roboto, sans-serif",
            size: "50px",
            color: "#55A9CB",
            weight: "900",
            lineHeight: "1.25",
            css: css`
                margin: 0 0 0.5em;
                display: block;
            `,
        },
        h2: {
            fontFamily: "Roboto, sans-serif",
            size: "42px",
            color: "#042359",
            weight: "900",
            lineHeight: "1.3",
            css: css`
                margin: 0 0 0.5em;
                display: block;
            `,
        },
        h3: {
            fontFamily: "Roboto, sans-serif",
            size: "34px",
            color: "#55A9CB",
            weight: "900",
            lineHeight: "1.3",
            css: css`
                margin: 0 0 0.5em;
                display: block;
            `,
        },
        h4: {
            fontFamily: "Roboto, sans-serif",
            size: "28px",
            color: "#363936",
            weight: "900",
            lineHeight: "1.3",
            css: css`
                margin: 0 0 0.5em;
                display: block;
            `,
        },
        h5: {
            fontFamily: "Roboto, sans-serif",
            size: "24px",
            color: "#363936",
            weight: "900",
            lineHeight: "1.3",
            css: css`
                margin: 0 0 0.5em;
                display: block;
            `,
        },
        h6: {
            fontFamily: "Roboto, sans-serif",
            size: "20px",
            color: "#363936",
            weight: "900",
            lineHeight: "1.4",
            css: css`
                margin: 0 0 0.5em;
                display: block;
            `,
        },
        legend: {
            color: "#DF2323",
            weight: 600,
            italic: false,
            underline: false,
            size: "15px",
            lineHeight: "1.5",
            transform: "uppercase",
            fontFamily: `"Inter Tight", Arial, sans-serif`,
        },
    },
    button: {
        primary: {
            color: "",
            shape: "rectangle",
            shadow: false,
            activeMode: "darken",
            hoverMode: "darken",
            // hoverAnimation: hoverAnimations.grow(),
            hoverAnimation: hoverAnimations.none,
            sizeVariant: "medium",
            buttonType: "solid",
            typographyProps: {
                weight: "bold",
            },
            typography: {
                color: "#ffffff",
                weight: "",
                italic: false,
                underline: false,
                fontFamily: "",
                size: "",
                lineHeight: "",
                textTransform: "none",
                letterSpacing: "",
            },
            textColor: "",
            css: css`
                font-size: 14px; // optional default, CMS will override
            `,
        } as any,
    } as any,

    footer: {
        isFullWidth: true,
        fullWidthStylingType: "solidColor",
        fullWidthColor: "#fff",
        fullWidthImage: "",
        fullWidthImageFocalPoint: "center",
    },
    header: {
        isCompactHeader: false,
        triggerPoint: 330,
        backgroundColor: "secondary.main",
        linkColor: "#fff",
        isDropShadow: false,
        dropShadowStyle: "medium",
        isBorderTop: false,
        isBorderBottom: false,
        isBorderRight: false,
        isBorderLeft: false,
        borderThickness: 0,
        borderColor: "#000",
        padding: 0,
        isBorder: false,
        isFullWidth: true,
        fullWidthStylingType: "solidColor",
        fullWidthColor: "#fff",
        fullWidthImage: "",
        fullWidthImageFocalPoint: "center",
    },
    breadcrumbs: {
        defaultProps: {
            typographyProps: {
                transform: "uppercase",
                weight: 500,
                lineHeight: "1.4",
                size: 19, // px
                color: "#1f2937",
                underline: false,
                italic: false,
                fontFamily: `"Inter Tight", Arial, sans-serif`,
                css: css`
                    font-family: "Inter Tight", Arial;
                    transition: color 0.3s ease;
                    background-color: transparent;
                    letter-spacing: 0.28px;
                    list-style: none;
                `,
            },
        },
    },
    tag: {
        defaultProps: {
            color: "#1f2937",
            typographyProps: {
                transform: "uppercase",
                weight: 600,
                lineHeight: "1.5",
                size: "15px",
                underline: false,
                italic: false,
                fontFamily: `"Inter Tight", Arial, sans-serif`,
            },
        },
    },
    tooltip: {
        defaultProps: {
            mergeCss: true,
            iconProps: {
                color: "secondary.main",
                src: "HelpCircle",
                size: 18,
            },
            typographyProps: {
                size: 13,
                color: "common.background",
                weight: 500,
            },
            cssOverrides: {
                tooltipContainer: css`
                    margin-left: 6px;
                `,
                tooltipBody: css`
                    background: ${getColor("common.backgroundContrast")};
                    color: ${getColor("common.background")};
                    border-radius: 6px;
                    padding: 8px 10px;
                `,
                tooltipArrow: css`
                    border-top-color: ${getColor("common.backgroundContrast")};
                `,
            },
        },
    },
});
